export default __webpack_public_path__ + "images/student/avatars/Oolzoo-d3f4cacf6568db31383f0955bcc026bf.svg";